import { render, staticRenderFns } from "./ProductionStatusCellRenderer.vue?vue&type=template&id=160a49ba&scoped=true&lang=pug&"
import script from "./ProductionStatusCellRenderer.vue?vue&type=script&lang=ts&"
export * from "./ProductionStatusCellRenderer.vue?vue&type=script&lang=ts&"
import style0 from "./ProductionStatusCellRenderer.vue?vue&type=style&index=0&id=160a49ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160a49ba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
